import type { ChartPanel } from 'features/charts-v2/types/filter-hash/v2'

type PanelDefaultsKeys =
  | 'widthMode'
  | 'filters'
  | 'searchTerms'
  | 'searchCriteria'
  | 'smartSearchEnabled'
  | 'canvasMode'
  | 'sortDirection'
  | 'chartFontSize'
  | 'showXAxisLabel'
  | 'showYAxisLabel'
  | 'showDatapointLabels'
  | 'datapointLabelsMode'
  | 'xAxisOverflow'
  | 'yAxisOverflow'
  | 'showSentimentZones'
  | 'showRatingZones'
  | 'scaleVolume'
  | 'showTrendline'
  | 'breakdownLabelMode'
  | 'showLegend'
  | 'showBreakdownHierarchy'
  | 'showCardLabels'
  | 'tableFontSize'
  | 'pageSize'
  | 'currentPage'

export const DEFAULT_PANEL_FIELDS: Pick<ChartPanel, PanelDefaultsKeys> = {
  widthMode: 'half',
  filters: [],
  searchTerms: [],
  searchCriteria: {},
  smartSearchEnabled: false,
  canvasMode: 'chart',
  sortDirection: 'DESC',
  chartFontSize: 'M',
  showXAxisLabel: true,
  showYAxisLabel: true,
  showDatapointLabels: true,
  // New panels default to density-aware auto: dense multi-series line charts
  // hide their inline labels (unreadable) while sparse charts keep them.
  datapointLabelsMode: 'on',
  xAxisOverflow: 'expand',
  yAxisOverflow: 'expand',
  showSentimentZones: true,
  showRatingZones: true,
  scaleVolume: false,
  showTrendline: false,
  breakdownLabelMode: 'tooltip',
  showLegend: true,
  showBreakdownHierarchy: false,
  showCardLabels: false,
  tableFontSize: 'M',
  pageSize: 'all',
  currentPage: 1,
}
